export const KAIROS_QOL_INGEST_PROGRESS_MARKER = 'KAIROS_QOL_INGEST_PROGRESS_THUMBNAIL_BADGE';
export const KAIROS_QOL_FIRST_IMAGE_DRAG_MARKER = 'KAIROS_QOL_FIRST_IMAGE_ON_THUMBNAIL_DROP';

const numericValue = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

export const resolveSeriesInstanceCount = (series = {}) => {
  const count = numericValue(series.displayFrameCount ?? series.numInstances ?? series.num_instances ?? series.instanceCount ?? series.instance_count ?? series.instancesReceived ?? series.receivedInstances);
  return count != null ? Math.max(0, Math.floor(count)) : 0;
};

export const resolveSeriesExpectedCount = (series = {}) => {
  const expected = numericValue(series.expectedInstances ?? series.expectedInstanceCount ?? series.instancesExpected ?? series.instanceCountExpected ?? series.expected_instance_count ?? series.numberOfSeriesRelatedInstances);
  return expected != null ? Math.max(0, Math.floor(expected)) : null;
};

export const getSeriesMiddleSlice = (series = {}) => Math.max(0, Math.floor((Math.max(1, resolveSeriesInstanceCount(series)) - 1) / 2));

export const getSeriesThumbnailSlice = (series = {}) => {
  const explicit = numericValue(series._kairosThumbnailSlice);
  if (explicit != null) return Math.max(0, Math.floor(explicit));
  return getSeriesMiddleSlice(series);
};

export const getSeriesFirstDragSlice = (series = {}) => {
  const explicit = numericValue(series._kairosInitialSlice);
  if (explicit != null) return Math.max(0, Math.floor(explicit));
  return 0;
};

export const buildSeriesDragItem = (series = {}) => ({
  ...series,
  _kairosInitialSlice: getSeriesFirstDragSlice(series),
  _kairosDragBehavior: KAIROS_QOL_FIRST_IMAGE_DRAG_MARKER,
});

export const isSeriesIngesting = (series = {}) => {
  const status = String(series.ingestStatus ?? series.ingestionStatus ?? series.receiveStatus ?? series.processingStatus ?? series.readinessStatus ?? series.renderStatus ?? '').toLowerCase();
  if (/ingest|receiv|process|pending|warming|partial|in[ _-]?progress/.test(status)) return true;
  const expected = resolveSeriesExpectedCount(series);
  const current = resolveSeriesInstanceCount(series);
  if (expected != null && expected > current) return true;
  const remaining = numericValue(series.remainingInstances ?? series.instancesRemaining ?? series.pendingInstances ?? series.pending_images);
  return remaining != null && remaining > 0;
};

export const formatIngestProgressLabel = (series = {}) => {
  if (!isSeriesIngesting(series)) return '';
  const current = resolveSeriesInstanceCount(series);
  const expected = resolveSeriesExpectedCount(series);
  if (expected && expected > current) return `RECEIVING ${current}/${expected}`;
  const remaining = numericValue(series.remainingInstances ?? series.instancesRemaining ?? series.pendingInstances ?? series.pending_images);
  if (remaining && remaining > 0) return `RECEIVING +${Math.floor(remaining)}`;
  return 'RECEIVING';
};
